module.exports = __webpack_public_path__ + "img/004-boy-1.4145cf37.svg";